import { useCallback, useState } from 'react'
import SigninModal from '@components/modals/signin'
import cx from 'classnames'

import Image from 'next/image'
import Router from 'next/router'
import useAuth from '@/hooks/auth'
import SectionContainer from './section-container'
import styles from './for-artists.module.scss'

const ForArtists = () => {
  const [ isOpen, setOpen ] = useState(false)
  const { loggedin } = useAuth()

  const onGo = useCallback(() => {
    if (loggedin) {
      Router.push('/sound-new')
      return
    }
    setOpen(true)
  }, [ loggedin ])

  return (
    <div className={styles.container}>
      <div className={cx(styles.bgImgContainer, styles.gradBg)} />
      <SectionContainer bgSrc="/static/images/is/is-top@2x.jpg" className={styles.topSection}>
        <div className={styles.text}>
          <h1 className={`${styles.h1} tx-oswald tx-w700`}>
              YOUR SOUNDS
            <br />
              TO THE PEOPLE
          </h1>
          <p className={styles.description}>
              あなたの曲を、
            <br />
              もっと手軽にファンのもとへ
          </p>
        </div>
      </SectionContainer>
      <SectionContainer bgSrc="/static/images/is/is-share@2x.jpg" className={styles.section}>
        <div className={cx(styles.text, styles.leftArea)}>
          <h2 className={`${styles.h2} tx-oswald tx-w700`}>
              SHARE MUSIC
            <br />
              MADE EASY
          </h2>
          <p className={styles.description}>
              SOUND ON
              LIVEは誰でも手軽に楽曲のダウンロード販売やストリーミング共有できるサービスです。
          </p>
        </div>
      </SectionContainer>
      <SectionContainer bgSrc="/static/images/is/is-any@2x.jpg" className={styles.section}>
        <div className={cx(styles.text, styles.rightArea)}>
          <h2 className={`${styles.h2} tx-oswald tx-w700`}>
              ANY SOUNDS
            <br />
              YOU CAN SHARE
          </h2>
          <p className={styles.description}>
              これまでデジタル販売が難しかったデモ音源やライブ音源なども、録音してすぐに販売でき、ウェブサイトやSNSで共有して簡単にファンのもとに届きます。
          </p>
        </div>
      </SectionContainer>
      <SectionContainer bgSrc="/static/images/is/is-supported@2x.jpg" className={styles.section}>
        <div className={cx(styles.text, styles.leftArea)}>
          <h2 className={`${styles.h2} tx-oswald tx-w700`}>
              GET
            <br />
              SUPPORTED
          </h2>
          <p className={styles.description}>
              楽曲の価値はファンにおまかせ。最低価格を設定して、ファンはその金額以上のご希望の価格で購入することができます。
          </p>
        </div>
      </SectionContainer>
      <section className={cx(styles.section, styles.stepsection)}>
        <div className={styles.steps}>
          <div className={styles.stepContainer}>
            <div className={styles.stepNumber}>1</div>
            <div className="ps-relative">
              <Image
                className={styles.stepImg}
                src="/static/images/is/upload.svg"
                alt="upload"
                width={48}
                height={46}
              />
              <h3 className={`${styles.stepTitle} mb-5`}>
                  ファイルをドラッグして アップロード
              </h3>
              <p className={styles.stepDescription}>
                  アップロード画面へファイルをドラッグするだけで、簡単にアップロード。MP3だけでなくハイレゾのWAVファイルなどのほとんどのオーディオファイルに対応しています。
              </p>
            </div>
          </div>
          <div className={styles.stepContainer}>
            <div className={styles.stepNumber}>2</div>
            <div className="ps-relative">
              <Image
                className={styles.stepImg}
                src="/static/images/is/edit.svg"
                alt="edit"
                width={48}
                height={48}
              />
              <h3 className={`${styles.stepTitle} mb-5`}>
                  タイトルを入力してカバー画像をアップロード
              </h3>
              <p className={styles.stepDescription}>
                  タイトルや説明、歌詞などを入力し、カバー画像をアップロードするだけですぐに公開。迷うことなく入力することができます。
              </p>
            </div>
          </div>
          <div className={styles.stepContainer}>
            <div className={styles.stepNumber}>3</div>
            <div className="ps-relative">
              <Image
                className={styles.stepImg}
                src="/static/images/is/on.svg"
                alt="switch"
                width={72}
                height={30}
              />
              <h3 className={`${styles.stepTitle} mb-5`}>
                  価格を入力して販売を ONにするだけ
              </h3>
              <p className={styles.stepDescription}>
                  ストリーミング試聴だけでなく、ダウンロード販売を行う際は、価格を設定し販売をONにするだけですぐに始められます。
              </p>
            </div>
          </div>
        </div>
      </section>
      <button type="button" className={styles.startSection} onClick={onGo}>
        <div className={cx(styles.text, styles.leftArea, styles.start)}>
          <div>
            <h2 className={`${styles.h2} tx-oswald tx-w700`}>
              START FROM FREE
            </h2>
            <p className={styles.description}>
              アーティストへの還元率は85%！
              <br /> 配信料金は0円で、更新料も一切かかりません。
            </p>
          </div>
          <div className={styles.goBtnContainer}>
            <div className={styles.goBtn}>
              <Image
                className={styles.goBtnImg}
                src="/static/images/is/next.svg"
                alt="next"
                width={500}
                height={500}
              />
            </div>
          </div>
        </div>
      </button>
      <SigninModal open={isOpen} onClose={() => setOpen(false)} />
    </div>
  )
}

export default ForArtists
